export class Kmlmanager{
    public kml = {}; //kml as json object
    public scenariolayout: any = {}; //Scenariolayout = new Scenariolayout();
    public center:any = {}; //latlng of center
    colors: any;
    indexContour = 0;

    constructor(kmlString: string){
        this.scenariolayout.contours = [];
        this.scenariolayout.contourdefinitions = [];
        this.kml = JSON.parse(kmlString);

        //populate the contours in scenariolayout
        this.traverse(this.kml,(key:string,value:any)=>{
            if (key == "coordinates") this.convertStringToContour(value)
            if (key == "Point") this.establishCenter(value)
        });

        // do the contour definitions now
        let nContours = this.scenariolayout.contours.length
        this.colors = this.generateColorPalette({r:255,g:255,b:0},{r:255,g:0,b:0},nContours)

        for (let i=0;i<nContours;i++){
            let exposure = i /(nContours-1) * 100;
            this.scenariolayout.contourdefinitions.push({color: this.colors[i],exposure: exposure});
        }

        this.scenariolayout.center = this.center;
    }

    traverse(o:any,func: any) {
        for (var i in o) {
            func.apply(this,[i,o[i]]);  
            if (o[i] !== null && typeof(o[i])=="object") {
                //going one step down in the object tree!!
                this.traverse(o[i],func);
            }
        }
    }
    establishCenter(value: any){
        let sCenter = value.coordinates
        let ll = sCenter.split(",");
        this.center = {lat: ll[1]*1,lng: ll[0]*1}
    }

    convertStringToContour(s : string){

        let contour:any = [];
        let arraytemp = s.split(" ");
        arraytemp.forEach((at:any) =>{
            let ll = at.split(",");
            if (ll[0] != null && ll[1] !=null){
                contour.push({lat: ll[1]*1,lng: ll[0]*1})
            }
        });
        this.scenariolayout.contours.push(contour);
        this.indexContour += 1;
    }

    generateColorPalette(col1:{r:number,g:number,b:number},col2:{r:number,g:number,b:number}, nColors: number){
        let palette:any = []
        let nCols = nColors -1;
        for (let i = 0; i<nColors;i++){
            let r = col1.r + (col2.r-col1.r) * i / nCols
            let g = col1.g + (col2.g-col1.g) * i / nCols
            let b = col1.b + (col2.b-col1.b) * i / nCols
            let srgb = "rgb("+r.toFixed(0)+","+g.toFixed(0)+","+b.toFixed(0)+")";
            palette.push(srgb)
        }
        return palette
    }
}